<template>
  <div>
    <div class="botones-container " v-if="esOperadorServ">
      <v-btn class="stats-button common-botton" dark @click="verAsignadas">
        Asignadas ({{ counts.asignadas }})
      </v-btn>

      <v-btn class="stats-button common-botton" dark @click="verTramite">
        En trámite ({{ counts.enTramite }})
      </v-btn>
      <v-btn class="stats-button common-botton" dark @click="verPendientesInf">
        Pendientes de información ({{ counts.pendientesInf }})
      </v-btn>
      <v-btn class="stats-button common-botton" dark @click="verAtencionManual">
        Atención manual ({{ counts.atencionManual }})
      </v-btn>

      <v-btn class="stats-button common-botton" dark @click="verPendientes">
        Pendientes de autorización ({{ counts.pendientes }})
      </v-btn>
    </div>
    <v-expansion-panels elevation="0">
      <v-expansion-panel elevation="0">
        <v-expansion-panel-header style="padding: 35px">
          <h3 style="color: #42352e">Búsqueda detallada</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form ref="form" v-model="isFormValid" lazy-validation>
            <v-row dense>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.id"
                  label="No. Solicitud"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.poliza"
                  label="Certificado"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>

              <v-col cols="12" md="3">
                <v-menu
                  v-model="menuFecha"
                  :close-on-content-click="false"
                  :max-width="300"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      :value="datesSelectedString"
                      label="Rango de fechas"
                      outlined
                      dense
                      readonly
                      prepend-inner-icon="mdi-calendar"
                      background-color="white"
                      color="#b11f1f"
                      v-on="on"
                      v-bind="attrs"
                    />
                  </template>
                  <v-card :width="300">
                    <v-date-picker
                      v-model="form.fecha_creacion"
                      range
                      locale="es"
                      selected-items-text="2 seleccionadas"
                      :width="300"
                    ></v-date-picker>
                    <v-card-actions>
                      <v-btn small text @click="form.fecha_creacion = []"
                        >Limpiar</v-btn
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        small
                        text
                        color="primary"
                        @click="menuFecha = false"
                        >Listo</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.nombre"
                  label="Nombre"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.apellidoPaterno"
                  label="Apellido Paterno"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.apellidoMaterno"
                  label="Apellido Materno"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.rfc"
                  label="RFC"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.celular"
                  label="Teléfono"
                  outlined
                  dense
                  prepend-inner-icon="mdi-phone"
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.email"
                  label="Correo electrónico"
                  outlined
                  dense
                  prepend-inner-icon="mdi-email"
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div class="pt-5">
      <v-row>
        <v-col cols="6" md="2">
          <v-select
            v-model="form.status"
            :items="statuslist"
            item-value="id"
            item-text="nombre"
            label="Estatus"
            color="#b11f1f"
            outlined
            background-color="white"
            dense
          />
        </v-col>
        <v-col cols="6" md="2">
          <v-select
            v-model="form.tipo"
            :items="tipoList"
            label="Tipo"
            outlined
            color="#b11f1f"
            background-color="white"
            dense
          />
        </v-col>
        <v-col cols="6" md="2">
          <v-select
            v-model="form.beneficios"
            :items="beneficiosList"
            item-value="id"
            item-text="nombreCorto"
            label="Tipo de beneficio"
            multiple
            chips
            small-chips
            clearable
            outlined
            color="#b11f1f"
            background-color="white"
            dense
          >
            <template v-slot:prepend-item>
              <v-list-item
                ripple
                @click="toggleTodosBeneficios"
              >
                <v-list-item-action>
                  <v-icon>
                    {{
                      todosBeneficiosSeleccionados
                        ? "mdi-checkbox-marked"
                        : "mdi-checkbox-blank-outline"
                    }}
                  </v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>
                    Seleccionar todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider class="mt-2"></v-divider>
            </template>

            <template v-slot:selection="{ item, index }">
              <v-chip
                v-if="index === 0"
                small
              >
                {{ item.nombreCorto }}
              </v-chip>

              <span
                v-if="index === 1"
                class="grey--text text-caption ml-1"
              >
                (+{{ form.beneficios.length - 1 }})
              </span>
            </template>
          </v-select>
        </v-col>
        <v-col cols="6" md="2">
          <v-select
            v-model="form.categoria"
            :items="categorias"
            label="Categoria"
            outlined
            color="#b11f1f"
            background-color="white"
            dense
          />
        </v-col>
        <v-col cols="6" md="2">
          <v-select
            v-model="form.operador_id"
            :items="operadores"
            item-text="nombreCompleto"
            item-value="id"
            label="Operador"
            outlined
            color="#b11f1f"
            background-color="white"
            dense
          />
        </v-col>

        <v-col cols="12" md="2" class="d-flex justify-end align-center">
          <v-btn
            dark
            outlined
            color="#b11f1f"
            rounded
            class="mr-2"
            min-width="90"
            @click="clearForm()"
          >
            Limpiar
          </v-btn>
          <v-btn
            class="common-botton"
            dark
            min-width="90"
            :disabled="!isFormValid || !minimoUnCampoLleno"
            :loading="loading"
            @click="updateSearch"
          >
            Filtrar
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mainAxios } from "@/mainAxios";
import moment from "moment";
import { getSolicitudesCount } from "@/services/solicitudService";
import { getAllCampaniasPostVenta } from "@/services/campaniasPostventa";
import { getBeneficiosList } from "@/components/clubBeneficios/clubBeneficiosService";

export default {
  props: {
    currentFilters: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        id: "",
        certificado: "",
        producto_id: "",
        fecha_creacion: [],
        nombre: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        rfc: "",
        celular: "",
        email: "",
        tipo: "",
        status: "",
        ramo: "",
        operador_id: "",
        tarjeta: "",
        beneficios: [],
      },
      producto_id: "",
      isFormValid: true,
      error: "",
      menuFecha: false,
      rango_fechas: [],
      tipoList: ["Redención Beneficio", "Redención Asistencia", "Retención"],
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      categorias: [
        "Redención Normal",
        "Redención sin Emisión",
        "Redención por Excepción",
      ],
      statuslist: [],
      productos_aseguradora: [],
      operadores: [],
      beneficiosList: [],
      counts: {
        asignadas: 0,
        enTramite: 0,
        pendientesInf: 0,
        pendientes: 0,
        atencionManual: 0,
      },
    };
  },
  computed: {
    datesSelectedString() {
      if (this.form.fecha_creacion.length > 1)
        return `${this.formatDate(
          this.form.fecha_creacion[0]
        )} a ${this.formatDate(this.form.fecha_creacion[1])}`;
      return "";
    },

    minimoUnCampoLleno() {
      return Object.keys(this.form).some((key) => {
        const value = this.form[key];

        if (Array.isArray(value)) {
          return value.length > 0;
        }

        return value !== "" && value !== null && value !== undefined;
      });
    },
    esOperadorServ() {
      return ["OPERADORSERVICIOS", "ADMIN"].includes(this.rol);
    },
    todosBeneficiosSeleccionados() {
      return (
        this.beneficiosList.length > 0 &&
        this.form.beneficios.length ===
          this.beneficiosList.length
      );
    },
  },
  methods: {
    clearForm() {
      Object.keys(this.form).forEach((key) => {
        if (key === "fecha_creacion" || key === "beneficios") {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      });
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatedDates() {
      let inicioUTC = null;
      let finUTC = null;
      if (this.form.fecha_creacion.length > 0) {
        if (this.form.fecha_creacion[1]) {
          inicioUTC = moment
            .utc(this.form.fecha_creacion[0])
            .subtract(6, "hours")
            .format("YYYY-MM-DD HH:mm:ss");
          finUTC = moment
            .utc(this.form.fecha_creacion[1])
            .subtract(6, "hours")
            .add(24, "hours")
            .subtract(1, "seconds")
            .format("YYYY-MM-DD HH:mm:ss");
        } else {
          inicioUTC = moment
            .utc(this.form.fecha_creacion[0])
            .subtract(6, "hours")
            .format("YYYY-MM-DD HH:mm:ss");
          finUTC = moment
            .utc(this.form.fecha_creacion[0])
            .subtract(6, "hours")
            .add(24, "hours")
            .subtract(1, "seconds")
            .format("YYYY-MM-DD HH:mm:ss");
        }
        return [inicioUTC, finUTC];
      }
      return null;
    },

    getProductosAseguradora() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      mainAxios
        .get("v1/producto/productosAseguradora", config)
        .then((response) => {
          this.productos_aseguradora = response.data.data.productos;
        });
    },

    async getOperadores() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      const payload = {
        roles: ["OPERADOR", "OPERADORASIST"],
        status: 1,
        paginado: false,
      };

      this.operadores = [];

      mainAxios.post("/v1/agente/filter/list", payload, config).then(({ data }) => {
        const agentes = data?.data?.agentes || [];
        const operadoresMap = new Map();

        console.log("data ", data)
        agentes.forEach((agente) => {
          operadoresMap.set(agente.id, {
            correo: agente.correo,
            nombreCompleto:
              agente.nombreCompleto ||
              `${agente.nombre || ""} ${agente.apellidoPaterno || ""} ${
                agente.apellidoMaterno || ""
              }`.trim(),
            id: agente.id,
            uuid: agente.uuid,
            rol: agente.roles?.[0]?.rol || agente.rol || null,
            roles: agente.roles || [],
          });
        });

        this.operadores = Array.from(operadoresMap.values());
      });
    },

    getStatus() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      mainAxios.get("/v1/solicitud/status/lista", config).then((resp) => {
        this.statuslist = resp.data.data.statusSolicitud;
      });
    },

    updateSearch() {
      if (!this.isFormValid || !this.minimoUnCampoLleno) return;

      const payload = {};

      Object.keys(this.form).forEach((key) => {
        const value = this.form[key];

        if (
          value === "" ||
          value === null ||
          value === undefined
        ) return;

        if (
          Array.isArray(value) &&
          value.length === 0
        ) return;

        payload[key] = value;
      });

      this.$emit("searchUpdated", payload);

    },

    setCurrent() {
      this.clearForm();
      this.form = { ...this.form, ...this.currentFilters };
    },
    async getCountSolicitudes() {
      const data = await getSolicitudesCount();
      // const data = res.data;
      const asignadas = data.find((item) => item.status === 10)?.cantidad || 0;
      const enTramite = data.find((item) => item.status === 2)?.cantidad || 0;
      const pendientesInf =
        data.find((item) => item.status === 11)?.cantidad || 0;
      const atencionManual =
        data.find((item) => item.status === 7)?.cantidad || 0;

      const pendientes =
        data.find((item) => [9].includes(item.status))?.cantidad || 0;

      this.counts = {
        asignadas,
        enTramite,
        pendientesInf,
        pendientes,
        atencionManual,
      };
    },

    async loadCampanias() {
      try {
        const res = await getAllCampaniasPostVenta();
        this.campaniasRaw = res || [];
        const tiposSolicitud = [
          ...new Set(this.campaniasRaw.map((c) => c.tipificacion)),
        ];

        const categoriasList = [
          ...new Set(this.campaniasRaw.map((c) => c.campania)),
        ];

        const catFromServer = new Set([...this.categorias, ...categoriasList]);
        this.categorias = [...catFromServer];

        const typesFromServer = new Set([...this.tipoList, ...tiposSolicitud]);

        this.tipoList = [...typesFromServer];
      } catch (error) {
        console.error("Error al cargar campañas:", error);
      }
    },

    aplicarFiltroPorEstado(status) {
      const filter = { status };

      // Solo se agrega el filtro por agente loggeado si no son status 7 ni 9
      if (status !== 7 && status !== 9) {
        filter.self_operador = "";
      }
      this.$emit("searchUpdated", filter);
    },
    verAsignadas() {
      this.aplicarFiltroPorEstado(10);
    },
    verTramite() {
      this.aplicarFiltroPorEstado(2);
    },
    verPendientesInf() {
      this.aplicarFiltroPorEstado(11);
    },
    verPendientes() {
      this.aplicarFiltroPorEstado(9);
    },
    verAtencionManual() {
      this.aplicarFiltroPorEstado(7);
    },
    async getBeneficios() {
      try {
        const response = await getBeneficiosList();

        this.beneficiosList = (response.clubBeneficios || [])
          .filter((beneficio) => beneficio.status === "Activo");

      } catch (error) {
        console.error(
          "Error al cargar beneficios:",
          error
        );

        this.$toast.error(
          "No se pudieron cargar los beneficios"
        );
      }
    },
    toggleTodosBeneficios() {
      if (this.todosBeneficiosSeleccionados) {
        this.form.beneficios = [];
        return;
      }

      this.form.beneficios =
        this.beneficiosList.map(
          (beneficio) => beneficio.id
        );
    },
  },

  mounted() {
    this.getCountSolicitudes();
    this.getProductosAseguradora();
    this.getOperadores();
    this.getStatus();
    this.loadCampanias();
    this.getBeneficios();
  },
};
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 20px;
}
.v-expansion-panels {
  z-index: auto !important;
}
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 20px !important;
  background-color: #fcf2f2;
}
.v-expansion-panel-header {
  background-color: #fcf2f2;
  border-radius: 20px !important;
}
.botones-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 20px;
}

.stats-button {
  width: 300px;
  height: 40px !important;
  font-size: small;
  font-weight: bold;
  margin-top: 10px;
}
</style>
